export default {
	namespaced: true,
	state: {
		variables: []
	},
	getters: {
		variables: state => state.variables
	},
	mutations: {
		PUSH_VARIABLE(state, payload) {
			state.variables.push(payload)
		},
		RESET_VARIABLES(state) {
			state.variables = []
		}
	},
	actions: {
		doPush({ state, commit }, payload) {
			const exists = state.variables.findIndex(s => s.node.id === payload.node.id)
			if (exists === -1) {
				// se non esiste la pusho
				if (payload.node.rules.length !== 0) payload.node.rules = JSON.parse(payload.node.rules)
				commit("PUSH_VARIABLE", payload)
			}
		}
	}
}
